import React from 'react';
// import classnames
import classnames from 'classnames';

const ButtonOutlineGray = ({ text, addClass, children, handdleClick }) => {
  return (
    <button
      className={classnames(
        `bg-white border border-font-gray-light py-2 px-3 rounded-md text-font-gray text-${text} ${addClass}`
      )}
      onClick={handdleClick}
    >
      {children}
    </button>
  );
};

export default ButtonOutlineGray;
